import { withRouter } from 'react-router-dom';
import { withUser } from 'components/queries/GetUserQuery';

import PassengerForm from './PassengerForm';

export default withRouter(withUser(PassengerForm));
